var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-column h-100" }, [
    _c("div", { staticClass: "navbar py-0", class: _vm.theme }, [
      _vm._m(0),
      _c(
        "form",
        { staticClass: "form-inline my-2 my-lg-0 ephemeral-form" },
        [
          !_vm.isEmbedded
            ? [
                _c("label", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary btn-sm mr-sm-2",
                      attrs: { role: "button" },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: ["fas", "upload"],
                          title: _vm.T.wordsUpload,
                          "aria-hidden": "true",
                          "data-zip-upload": "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("input", {
                    staticClass: "d-none",
                    attrs: { type: "file", accept: ".zip" },
                    on: { change: _vm.handleUpload },
                  }),
                ]),
                _c("label", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary btn-sm mr-sm-2",
                      attrs: {
                        role: "button",
                        href: _vm.zipHref,
                        download: _vm.zipDownload,
                        "data-zip-download": "",
                      },
                      on: { click: _vm.handleDownload },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.isDirty
                            ? ["fas", "file-archive"]
                            : ["fas", "download"],
                          title: _vm.isDirty
                            ? _vm.T.zipPrepare
                            : _vm.T.wordsDownload,
                          "aria-hidden": "true",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("label", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm mr-2",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleTheme.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.isDark ? ["fas", "sun"] : ["fas", "moon"],
                          "aria-hidden": "true",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard",
                          value: _vm.getCopySource,
                          expression: "getCopySource",
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.handleCopyFeedback,
                          expression: "handleCopyFeedback",
                          arg: "success",
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:error",
                          value: _vm.handleCopyError,
                          expression: "handleCopyError",
                          arg: "error",
                        },
                      ],
                      staticClass: "btn btn-sm mr-2 my-sm-0",
                      class: _vm.isCopySuccess
                        ? "btn-success"
                        : "btn-secondary",
                      attrs: {
                        type: "button",
                        "data-copy-button": "",
                        title: _vm.T.wordsCopyToClipboard,
                        "aria-label": _vm.T.wordsCopyToClipboard,
                        "copy-to-clipboard": "",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "copy"], "aria-hidden": "true" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedLanguage,
                  expression: "selectedLanguage",
                },
              ],
              staticClass: "form-control form-control-sm mr-sm-2",
              attrs: { "data-language-select": "" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedLanguage = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _vm.languages.length > 1
                ? _c("optgroup", { attrs: { label: _vm.T.detectLanguage } }, [
                    _c("option", { attrs: { value: "auto-detect" } }, [
                      _vm._v(_vm._s(_vm.T.detectLanguage)),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "optgroup",
                { attrs: { label: _vm.T.settingsLanguage } },
                _vm._l(_vm.languages, function (language) {
                  return _c(
                    "option",
                    { key: language, domProps: { value: language } },
                    [_vm._v(" " + _vm._s(_vm.getLanguageName(language)) + " ")]
                  )
                }),
                0
              ),
            ]
          ),
          _c("label", [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-sm mr-2",
                attrs: { title: _vm.T.resetTemplate },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.resetToTemplate.apply(null, arguments)
                  },
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "undo"], "aria-hidden": "true" },
                }),
              ],
              1
            ),
          ]),
          _vm.showDetectedLabel
            ? _c(
                "div",
                {
                  staticClass:
                    "language-detected d-flex align-items-center mr-2",
                },
                [
                  _c("span", { staticClass: "language-detected-text mr-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.ui.formatString(_vm.T.languageDetected, {
                            lang: _vm.detectedDisplayName,
                          })
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success mr-1",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.acceptDetectedLanguage.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.T.switchLanguage) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-secondary",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.rejectDetectedLanguage.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.ui.formatString(_vm.T.keepLanguage, {
                              lang: _vm.currentLanguageName,
                            })
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm.isRunButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-secondary mr-2 my-sm-0",
                  class: { disabled: !_vm.canExecute },
                  attrs: { disabled: !_vm.canExecute, "data-run-button": "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleRun.apply(null, arguments)
                    },
                  },
                },
                [
                  !_vm.canExecute
                    ? _c("omegaup-countdown", {
                        attrs: {
                          "target-time": _vm.nextExecutionTimestamp,
                          "countdown-format":
                            _vm.omegaup.CountdownFormat.EventCountdown,
                        },
                        on: {
                          finish: function ($event) {
                            _vm.now = Date.now()
                          },
                        },
                      })
                    : [
                        _c("span", [_vm._v(_vm._s(_vm.T.wordsRun))]),
                        _vm.isRunLoading
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status", "aria-hidden": "true" },
                            })
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm.isSubmitButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary my-2 my-sm-0",
                  class: { disabled: !_vm.canSubmit },
                  attrs: { disabled: !_vm.canSubmit, "data-submit-button": "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  !_vm.canSubmit
                    ? _c("omegaup-countdown", {
                        attrs: {
                          "target-time": _vm.nextSubmissionTimestamp,
                          "countdown-format":
                            _vm.omegaup.CountdownFormat.EventCountdown,
                        },
                        on: {
                          finish: function ($event) {
                            _vm.now = Date.now()
                          },
                        },
                      })
                    : [
                        _c("span", [_vm._v(_vm._s(_vm.T.wordsSubmit))]),
                        _vm.isSubmitLoading
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status", "aria-hidden": "true" },
                            })
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
    _c("section", { ref: "layout-root", staticClass: "col px-0 flex-grow-1" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "navbar-brand" }, [
      _vm._v(" omegaUp ephemeral grader "),
      _c("sup", [_vm._v("α")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }